module.exports = __webpack_public_path__ + "static/logo-aed1216056d54b991f442243015fdcf7.png";